export default "__VITE_ASSET__01c65e5c__"